import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Layout from '../components/Layout';
import Home from '../pages/Home/Home';
import Settings from '../pages/Settings/Settings';
import Login from '../pages/Auth/Login';
import AccountLogin from '../pages/Auth/AccountLogin';
import Word from '../pages/Word/Word';
import Text from '../pages/Text/Text';
import Exercises from '../pages/Exercises';
import Solo from '../pages/Solo/Solo';
import Dictation from '../pages/Dictation/Dictation';
import Reading from '../pages/Reading/Reading';
import TextReading from '../pages/TextReading/TextReading';
import RolePlay from '../pages/RolePlay/RolePlay';
import ResourceExtension from '../pages/ResourceExtension';
import NotFound from '../pages/NotFound/NotFound';
import QuantityGame from '../pages/PKGame/QuantityGame';
import TimedGame from '../pages/PKGame/TimedGame';
import RushAnswerGame from '../pages/PKGame/RushAnswerGame';
import UserStats from '../pages/UserStats/UserStats';

// 私有路由组件
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/account-login" replace />;
  }
  return children;
};

// 布局路由组件 - 减少重复包装
const LayoutRoute = () => {
  return (
    <PrivateRoute>
      <Layout>
        <Outlet />
      </Layout>
    </PrivateRoute>
  );
};

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path="/account-login" element={<AccountLogin />} />
        <Route path="/login" element={
          <PrivateRoute>
            <Login />
          </PrivateRoute>
        } />
        {/* 独立页面路由 - 不包含导航栏 */}
        <Route path="/dictation" element={
          <PrivateRoute>
            <Dictation />
          </PrivateRoute>
        } />
        <Route path="/reading" element={
          <PrivateRoute>
            <Reading />
          </PrivateRoute>
        } />
        <Route path="/text-reading" element={
          <PrivateRoute>
            <TextReading />
          </PrivateRoute>
        } />
        <Route path="/role-play" element={
          <PrivateRoute>
            <RolePlay />
          </PrivateRoute>
        } />
        <Route path="/quantity-game" element={
          <PrivateRoute>
            <QuantityGame />
          </PrivateRoute>
        } />
        <Route path="/timed-game" element={
          <PrivateRoute>
            <TimedGame />
          </PrivateRoute>
        } />
        <Route path="/rush-answer-game" element={
          <PrivateRoute>
            <RushAnswerGame />
          </PrivateRoute>
        } />
        <Route path="/" element={<LayoutRoute />}>
          <Route index element={<Navigate to="/word" replace />} />
          <Route path="dashboard" element={<Home />} />
          <Route path="settings" element={<Settings />} />
          <Route path="word" element={<Word />} />
          <Route path="text" element={<Text />} />
          <Route path="exercises" element={<Exercises />} />
          <Route path="solo" element={<Solo />} />
          {/* 资源拓展路由 */}
          <Route path="good-reading" element={<ResourceExtension />} />
          <Route path="premium-teaching" element={<ResourceExtension />} />
          <Route path="special-breakthrough" element={<ResourceExtension />} />
          <Route path="exam-strategy" element={<ResourceExtension />} />
          <Route path="resource-download" element={<ResourceExtension />} />
          <Route path="user-stats" element={<UserStats />} />
          <Route path="resource" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default AppRouter;
